import React, {useState, useEffect} from 'react'
import * as txApi from '../clients/tx-sls-client'

export const useUserLoginDetails = (role) => {
  const [user_information, setUserInformation] = useState([])

  useEffect(() => {
    if(user_information.role !== role) {

      txApi.getLoggedInUserDetails()
        .then( result_user_information => {

            const logged_in_user_information = result_user_information ? result_user_information : null;
            
            /*
            const logged_in_user_information = [{
                display_name: "Judson Cooper",
                email: "sagar.khenat@biz4solutions.com",
                is_member: "0",
                role: "1",
                user_id: "3",
                emulate_user_id: "16",
                emulate_user_role: "3",
                user_login: "sagar10",
            }]
            */
            

            /*
            const logged_in_user_information = [{
                display_name: "Stephen Strange",
                email: "stephen2@mailinator.com",
                user_id: "34862",
                user_login: "stephenstrange",
                is_member: "0",
                role: "3"
            }]
            */
            

            /*
            const logged_in_user_information = [{
              display_name: "Martha Jones",
              email: "Martha@bizcollaborators.com",
              user_id: "24435",
              user_login: "Martha",
              is_member: "0",
              role: "3"
           }]
           */

            setUserInformation(logged_in_user_information)
            console.log('logged_in_user_information',logged_in_user_information );
        })
        .catch(error => console.error(`Error retrieving logged in user details`))
    }

  }, [])

  return user_information[0]
}